import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export function PhoneIcon(props: SvgIconProps) {
  const defaultColor = '#3B3C40';
  return (
    <SvgIcon
      {...props}
      viewBox='0 0 16 16'
      fill='none'
    >
      <g id='Layer 2'>
        <g id='smartphone'>
          <path
            id='Vector'
            d='M11.3333 1.33331H4.66663C4.13619 1.33331 3.62749 1.54403 3.25241 1.9191C2.87734 2.29417 2.66663 2.80288 2.66663 3.33331V12.6666C2.66663 13.1971 2.87734 13.7058 3.25241 14.0809C3.62749 14.4559 4.13619 14.6666 4.66663 14.6666H11.3333C11.8637 14.6666 12.3724 14.4559 12.7475 14.0809C13.1226 13.7058 13.3333 13.1971 13.3333 12.6666V3.33331C13.3333 2.80288 13.1226 2.29417 12.7475 1.9191C12.3724 1.54403 11.8637 1.33331 11.3333 1.33331ZM12 12.6666C12 12.8435 11.9297 13.013 11.8047 13.1381C11.6797 13.2631 11.5101 13.3333 11.3333 13.3333H4.66663C4.48981 13.3333 4.32025 13.2631 4.19522 13.1381C4.0702 13.013 3.99996 12.8435 3.99996 12.6666V3.33331C3.99996 3.1565 4.0702 2.98693 4.19522 2.86191C4.32025 2.73688 4.48981 2.66665 4.66663 2.66665H11.3333C11.5101 2.66665 11.6797 2.73688 11.8047 2.86191C11.9297 2.98693 12 3.1565 12 3.33331V12.6666Z'
            fill={props.color ?? defaultColor}
          />
          <path
            id='Vector_2'
            d='M8 12C8.55228 12 9 11.5523 9 11C9 10.4477 8.55228 10 8 10C7.44772 10 7 10.4477 7 11C7 11.5523 7.44772 12 8 12Z'
            fill={props.color ?? defaultColor}
          />
          <path
            id='Vector_3'
            d='M9.66663 4H6.33329C6.15648 4 5.98691 4.07024 5.86189 4.19526C5.73686 4.32029 5.66663 4.48986 5.66663 4.66667C5.66663 4.84348 5.73686 5.01305 5.86189 5.13807C5.98691 5.2631 6.15648 5.33333 6.33329 5.33333H9.66663C9.84344 5.33333 10.013 5.2631 10.138 5.13807C10.2631 5.01305 10.3333 4.84348 10.3333 4.66667C10.3333 4.48986 10.2631 4.32029 10.138 4.19526C10.013 4.07024 9.84344 4 9.66663 4Z'
            fill={props.color ?? defaultColor}
          />
        </g>
      </g>
    </SvgIcon>
  );
}
